import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=726ba163&scoped=true&"
import script from "./CommentForm.vue?vue&type=script&lang=ts&"
export * from "./CommentForm.vue?vue&type=script&lang=ts&"
import style0 from "./CommentForm.vue?vue&type=style&index=0&id=726ba163&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726ba163",
  null
  
)

export default component.exports